import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarLancamentoPublicidadeDs,
} from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ShowError from "../../AppServices";
import uiInfo from "../../ui-info";
import { abrirDetalhe } from "../../lancamentosUtils";

const template = {
  _uiNumero: undefined,
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  ano: undefined,
  area: undefined,
  horario: "",
  valor: undefined,
  contribuinteId: undefined,
  data: undefined,
  dataDeVencimento: undefined,
  descricaoDaAtividade: "",
  localizacao: "",
  numero: undefined,
  situacaoStr: "N",
  validade: undefined,
  popupVisivel: false,
  exibirPopupPreview: false,
};

export default class LancamentoAlvaraPublicidade extends React.Component {
  constructor(props) {
    super(props);
    this.contribuinteDs = criarContribuinteDs();
    this.publicidadeDs = criarLancamentoPublicidadeDs();
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cancel = this.cancel.bind(this);
    this.state = {};
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      searchPlaceholder: "Procurar",
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: "N", descricao: "Normal" },
        { id: "I", descricao: "Isento" },
        { id: "C", descricao: "Cancelado" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.confirmar = this.confirmar.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.confirmarTela = this.confirmarTela.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      popupVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.publicidadeDs
        .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
        .then((response) => {
          if (response.length < 1) {
            notify("Registro não encontrado.", "error");
            this.props.history.goBack();
          } else {
            const data = response[0];

            let novoEstado = {
              _uiNumero: data.numeroCompleto,
              _uiNomeContribuinte: data.contribuinte.nome,
              id: data.id,
              sequencial: data.sequencial,
              prefeituraId: data.prefeituraId,
              ano: data.ano,
              area: data.qtdeLancamento,
              horario: data.horarioLancamento,
              valor: data.valorDoImposto,
              contribuinteId: data.contribuinte.sequencial,
              data: data.dataLancamento,
              dataDeVencimento: data.vencimentoAlvara,
              descricaoDaAtividade: data.historico,
              localizacao: data.localizacaoLancamento,
              numero: data.numeroLancamento,
              situacaoStr: data.situacaoStr,
              validade: data.validadeLancamento,
            };
            this.setState(novoEstado);
          }
        })
        .catch((erro) => {
          ShowError(erro);
          this.props.history.goBack();
        });
    } else {
      this.setState({
        ...template,
        data: new Date(),
        dataDeVencimento: new Date(),
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={4}>
              <GroupItem
                caption="VEICULAÇÃO DE PUBLICIDADE"
                colSpan={4}
                colCount={4}
              >
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumero"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  dataField={"data"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%" }}
                >
                  <Label text="Data" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  dataField={"dataDeVencimento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem
                  dataField={"validade"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Validade" />
                </SimpleItem>

                <EmptyItem colSpan={3} />

                <SimpleItem colSpan={4} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  dataField={"localizacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={4}
                >
                  <Label text="Localização" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"area"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Área (m²)" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"valor"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor" />
                </SimpleItem>

                <SimpleItem colSpan={2} dataField={"horario"}>
                  <Label text="Horário de Funcionamento" />
                </SimpleItem>

                <SimpleItem
                  dataField={"descricaoDaAtividade"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "110px" }}
                  colSpan={4}
                >
                  <Label text="Descrição da Atividade" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Pré-visualizar"
                  type="default"
                  onClick={this.confirmarTela}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.confirmarPopup}
                />
              </div>

              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={() => this.setState({ popupVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.exibirPopupPreview}
            onHiding={() => this.setState({ exibirPopupPreview: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={600}
            height={350}
            title="Confirmação dos dados"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.previewData}>
                  <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                    <Label text="Nome" />
                  </SimpleItem>

                  <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                    <Label text="CPF/CNPJ" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL1"}
                    render={this.itemLeitura}
                  >
                    <Label text="Endereco" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"enderecoL2"}
                    render={this.itemLeitura}
                  >
                    <Label text=" " showColon={false} />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"valor"}
                    render={this.itemLeituraMoeda}
                  >
                    <Label text="Valor" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: this.confirmarPopup,
              }}
            ></ToolbarItem>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPopupPreview: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  confirmarTela() {
    this.confirmar(true);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    // código modelo
    let entidade = { ...this.state };
    entidade.preview = preview;
    inserirOuAtualizar(this.publicidadeDs, entidade).then(
      function (data) {
        if (preview) {
          this.setState({
            exibirPopupPreview: true,
            previewData: {
              nome: data.lancamento.contribuinte.nome,
              fantasia: data.lancamento.contribuinte.fantasia,
              cpfCnpj: data.lancamento.contribuinte.documentoFormatado,
              enderecoL1: data.lancamento.contribuinte.logradouroComNumero,
              enderecoL2: data.lancamento.contribuinte.enderecoL2,
              ano: data.lancamento.ano,
              exercicio: data.lancamento.exercicio,
              situacao: data.lancamento.situacao.descricao,
              valor: data.lancamento.valorDoImposto,
            },
          });
        } else {
          abrirDetalhe(this.props.history, data);
        }
      }.bind(this)
    );
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
